import {authService} from "./index";

export const actionTypes = {
    LOAD: 'LOAD',
    LOGOUT: 'LOGOUT'
};

export function login(username, password, onSuccess, onError) {
    authService.login(username, password, onSuccess,
        error => {
            if (onError)
                if (!error.response)
                    onError("Ocorreu um erro durante a conexão com o servidor.");
                else
                    onError(error.response.data ? error.response.data.message : error.response.message);
        })
}

export function logout(onSuccess, onError) {
    return dispatch => {
        authService.logout();
        dispatch({type: actionTypes.LOGOUT});
        onSuccess();
    };
}

export function load(onSuccess, onError) {
    return dispatch => authService.token(
        success => {
            if(success.data.roles.length === 0){
                dispatch({type: actionTypes.LOGOUT});
                onError("forbidden")
            }else{
                dispatch({type: actionTypes.LOAD, auth: Object.assign(success.data)});
                onSuccess(success);
            }
        }, error => {
            onError(error);
        })
}






// WEBPACK FOOTER //
// ./src/auth/AuthActions.js